module.exports = __webpack_public_path__ + "static/media/GraduationRobeInSnowSquare.da0cf77c.jpg";